import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';

export default class DeleteDialog extends Component {

    render() {

        const customContentStyle = {
            width: '475px',
            backgroundColor: '#D82D49'
        };

        const { deleteButtonText, cancelText } = this.props;

        const actions = [
            <span
                data-cy='delete-dialog-cancel-button'
                className='portal-blank-button'
                onClick={this.props.closeDeleteDialog}
            >
                {cancelText}
            </span>,
            <Button 
                buttonType={ButtonType.red}
                onClick={this.props.onConfirm}
                inProgress={this.props.inProgress}
                text={deleteButtonText}
                dataCy={this.props.dataCy}
            >
            </Button>
        ];

        const title = <DialogHeader 
                        title={this.props.titleText}
                        closeClick={this.props.closeDeleteDialog}
                        displayCloseButton
                    />;

        return (
            <Dialog
                title={title}
                className='portal-confirm-dialog'
                bodyClassName='portal-confirm-dialog-body'
                actionsContainerClassName='portal-confirm-dialog-actions'
                actions={actions}
                modal={true}
                contentStyle={customContentStyle}
                open={this.props.show}
                >
                <div
                    data-cy={this.props.dialogDataCy}
                >
                    {this.props.contentText}
                </div>
            </Dialog>
        );
    }    
}